import { createApply } from './apply.js';
import { createList } from './list.js';
export function createProfiles(config) {
  return {
    apply: createApply(config),
    list: createList(config)
  };
}